import React from 'react';
// import PropTypes from 'prop-types';

import satImg from "../../assets/sat.jpg";
import codeImg from "../../assets/code.jpg";
import marketingImg from "../../assets/marketing.jpg";
import bg_img from "../../assets/newbg.jpg";

import overlay_logo from "../../assets/overlay-logo.png";
import { isInside } from './../../tools/Geometry';
// import { SimpleParallax } from '../../components/CustomParallax/SimpleParallax';
import { safeConnect, cssUrl } from '../../tools/Utils';
import "./SystemLogo.scss"

const insidePoly = [{x:0,y:50},{x:25,y:100},{x:75,y:100},{x:100,y:50},{x:75,y:0},{x:25,y:0}]
const codePoly  = [{x:50,y:50},{x:100,y:50},{x:75,y:0},{x:25,y:0}]
const marketingPoly = [{x:0,y:50},{x:25,y:100},{x:50,y:50},{x:25,y:0}]
const satPoly = [{x:50,y:50},{x:25,y:100},{x:75,y:100},{x:100,y:50}]
class _SystemLogo extends React.Component
{
	state = {scrollOffset:0,inside:false,code:false,marketing:false,sat:false};

	holder = React.createRef();

	addBg = (bg) =>
	{
		return {backgroundImage:`url(${cssUrl(bg)})`};
	}

	addBgWithOffset = (bg) =>
	{
		return {backgroundImage:`url(${cssUrl(bg)})`};
	}

	componentDidUpdate(oldProps)
	{
		if(oldProps.isLoaded!==this.props.isLoaded)
		{
			this.setState( {
				offsetTop:this.holder.current.offsetTop,
				offsetLeft:this.holder.current.offsetLeft,
				offsetHeight:this.holder.current.offsetHeight,
				offsetWidth:this.holder.current.offsetWidth
			})
		}
		else
		{
			if(oldProps.windowX!==this.props.windowX)
			{
				this.setState( {
					offsetLeft:this.holder.current.offsetLeft,
					offsetWidth:this.holder.current.offsetWidth
				})
			}
		
			if(oldProps.windowY!==this.props.windowY)
			{
				this.setState( {
					offsetTop:this.holder.current.offsetTop,
					offsetHeight:this.holder.current.offsetHeight,
				})
			}
		}
	}

	onMouseMove = (e) => 
	{
		const x = ((e.clientX-this.state.offsetLeft)/this.state.offsetWidth)*100;
		const y = ( (e.clientY-this.state.offsetTop+this.props.scrollY)/this.state.offsetHeight)*100 ;
		const inside = isInside(insidePoly, {x:x,y:y} )
		this.setState(
			{
				inside: inside,
				code: inside && isInside(codePoly, {x:x,y:y} ),
				marketing: inside && isInside(marketingPoly, {x:x,y:y} ),
				sat: inside && isInside(satPoly, {x:x,y:y} ),
			}
		)
	}

	onMouseLeave = () =>
	{
		this.setState( {inside:false,code:false,marketing:false,sat:false});
	}
	getHoverText = () =>
	{
		if(this.state.code)
			return <h2><span>Desarrollo</span></h2>;
		if(this.state.marketing)
			return <h2><span>Marketing</span></h2>;
		if(this.state.sat)
			return <h2><span>SAT</span></h2>;
	}
	getHref()
	{
		if(!this.state.inside)
			return '#';
		if(this.state.code)
			return "#dev";
		if(this.state.marketing)
			return "#marketing";
		if(this.state.sat)
			return "#sat";
	}
  
	render()
	{
		return (
			<div className={"system-logo image-block"} style={this.addBg(bg_img)}>
				<div className={`master-title ${this.state.inside?"hover":""}`}>
					<h1>SYSTEM·<span>3</span></h1>
					<div>{this.getHoverText()}</div>
				</div>
				<a href={this.getHref()} ref={this.holder} className={`holder ${this.state.inside?"hover":""}`}
				onMouseMove={this.onMouseMove} onMouseLeave={this.onMouseLeave} >
					<div className="logo-bg"> </div >
					<div className="logo-bg-2"> </div >
					<div className={`code face ${this.state.code?"hover":""}`}  >
						<div style={this.addBgWithOffset(codeImg)} ></div>
					</div >
					{/* <h1 className={`code title ${this.state.code?"hover":""}`} >Desarrollo</h1> */}
					<div className={`marketing face ${this.state.marketing?"hover":""}`} >
						<div style={this.addBgWithOffset(marketingImg)} ></div>
					</div >
					{/* <h1 className={`marketing title ${this.state.marketing?"hover":""}`} >Marketing</h1> */}
					<div className={`sat face ${this.state.sat?"hover":""}`}  >
						<div style={this.addBgWithOffset(satImg)} ></div>
					</div >
					{/* <h1 className={`sat title ${this.state.sat?"hover":""}`} >SAT</h1> */}
					<div className="logo-overlay" style={this.addBg(overlay_logo)}></div >
				</a>
				
			</div>
		);
	}
}

export const SystemLogo = safeConnect(
	(state, ownProps) =>
	{	
		return {
			scrollY:state.window.scroll.y,
			windowX:state.window.size.width,
			windowY:state.window.size.heigth,
			isLoaded:state.window.isLoaded,
		};
	}
)(_SystemLogo);
